// @flow

import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import Field from "src/containers/checklist/Field";

type Props = {
  id: string | number,
  position: number,
  updateField: Function,
  openSettings: Function,
  addFields: Function,
  removeField: Function,
};

function SortableItem({
  id,
  position,
  updateField,
  removeField,
  addFields,
  openSettings,
}: Props) {
  const { listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Field
      position={position}
      addFields={addFields}
      openSettings={openSettings}
      updateField={updateField}
      removeField={removeField}
      rowRef={setNodeRef}
      style={style}
      dragHandleRef={setActivatorNodeRef}
      dragHandleListeners={listeners}
    />
  );
}

export default SortableItem;
